import * as React from 'react';
import { TCheckbox } from './Checkbox.types';
import './Checkbox.styles.scss';

export const Checkbox: TCheckbox = ({
  checked,
  onChange,
  label,
  disabled = false,
}) => {
  return (
    <label className="checkbox body2">
      <input
        className="checkbox__input"
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="checkbox__label">{label}</span>
    </label>
  );
};
